import React, { useEffect, useState } from "react";
import { DndContext } from "@dnd-kit/core";
import { arrayMove, SortableContext } from "@dnd-kit/sortable";
import { SortableGroupItem } from "./sortable-group-item";

export const SortableGroup = ({
    attributeGroup,
    attributeList,
    attributeKey,
    readOnly,
    uuid,
    onSave,
    onRemove,
    onEditGroup,
    selectedId,
    setSelectedId,
    disabled,
    wipKey,
}) => {
    const attributeGroupUUID = attributeGroup.data[uuid];
    const [items, setItems] = useState(attributeGroupUUID);

    useEffect(() => {
        setItems(attributeGroupUUID);
    }, [attributeGroupUUID]);

    const handleOnDragStart = () => {
        if (selectedId) {
            setSelectedId(null);
        }
    };

    const handleOnDragEnd = ({ active, over }) => {
        if (!over) {
            return;
        }

        if (active.id !== over.id) {
            const oldIndex = items.findIndex((i) => i.id === active.id);
            const newIndex = items.findIndex((i) => i.id === over.id);
            const updatedList = arrayMove(items, oldIndex, newIndex);
            setItems(updatedList);
            onSave(updatedList);
        }
    };

    //The sortable context only accepts simple lists and not objects
    const attributesIndexList = items ? items.map((item) => item.id) : [];

    return (
        <DndContext
            onDragStart={handleOnDragStart}
            onDragEnd={handleOnDragEnd}
        >
            <div
                key={`${uuid}_${attributeKey}`}
                className="flex flex-wrap"
            >
                <SortableContext items={attributesIndexList}>
                    {attributeList.length > 0 &&
                        items &&
                        items.map((collection, index) => {
                            return (
                                <SortableGroupItem
                                    key={collection.id}
                                    id={collection.id}
                                    attributeList={attributeList}
                                    disabled={disabled}
                                    index={index}
                                    collection={collection}
                                    attributeKey={attributeKey}
                                    wipKey={wipKey}
                                    readOnly={readOnly}
                                    onRemove={onRemove}
                                    onEditGroup={onEditGroup}
                                />
                            );
                        })}
                </SortableContext>
            </div>
        </DndContext>
    );
};
